import { useCallback, useState, useEffect } from 'react'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'

import { useTranslation } from 'src/utils/i18n'
import Grid from '@mui/material/Grid'
import Icon from 'src/@core/components/icon'
import styles from '../../../styles/reminders.module.scss'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import IosVerfiyProcess from 'src/@core/components/ios-verfiy-process'
import { getReminderSummary, getReminderDetail } from 'src/@api/dashboard'
import Image from 'next/image'
import { setCurrentTab } from 'src/store/apps/Common'
import { useDispatch } from 'react-redux'
import ContentLoading from 'src/components/ContentLoading'

const Reminders = () => {
  const { t } = useTranslation('common') // 使用 i18next 进行国际化
  const [reminders, setReminders] = useState([]) // 存储提醒列表
  const [active, setActive] = useState(null) // 当前选中的提醒的 GUID
  const [initSelectData, setInitSelectData] = useState([]) // 初始选中的数据
  const [selectData, setSelectData] = useState([]) // 当前显示的选中数据
  const [remindersBoxes, setRemindersBoxes] = useState(1) // 移动端显示层级
  const [reminderTitle, setReminderTitle] = useState('') // 标题
  const [reminderCount, setReminderCount] = useState(0) // 总数
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据
  const formatDate = dateArray => {
    if (!dateArray || dateArray.length < 7) return ''
    const [fullDate, year, month, day, hour, minute, second] = dateArray

    return new Date(year, month - 1, day, hour, minute, second).toLocaleString()
  }
  const dispatch = useDispatch()
  const loadReminders = useCallback(async () => {
    setIsLoading(true)
    setReminders([])
    setSelectData([])
    setInitSelectData([])
    setActive(null)
    setRemindersBoxes(1)

    const username = JSON.parse(localStorage.getItem('DeviceUser'))?.username || ''
    const response = await getReminderSummary({
      username,
      params: {
        category: 'REMINDER_SUMMARY'
      }
    })

    const collections = response.data.contents?.Collections
    if (collections) {
      setReminders(collections)
      setReminderCount(collections.length)
    } else {
      setReminderCount(0)
    }
    setIsLoading(false)
  }, [])

  // 设备切换时重新拉数
  useDeviceScopedInit(loadReminders)

  // 处理选中提醒
  const handleSelectClick = async guid => {
    setRemindersBoxes(2)
    setActive(guid)

    const username = JSON.parse(localStorage.getItem('DeviceUser'))?.username || ''
    const selectData = await getReminderDetail({
      username,
      params: {
        category: 'REMINDER_DETAIL',
        offset: 0,
        limit: 10000,
        rid: guid
      }
    })

    const data = selectData.data.contents
    const result = [...(data.Collections || []), ...(data.Reminders || [])]
    setSelectData(result)
    setInitSelectData(result)

    const selectedReminder = reminders.find(item => item.guid === guid)
    setReminderTitle(selectedReminder?.title || '')
    setIsLoading(false)
  }

  // 搜索过滤
  const handleFilter = e => {
    const value = e.target.value.toLowerCase()

    if (value === '') {
      setSelectData(initSelectData)

      return
    }

    const filterData = initSelectData.filter(item => item.title.toLowerCase().includes(value))
    setSelectData(filterData)
  }

  // 设置当前选项卡
  useEffect(() => {
    dispatch(setCurrentTab(t('Reminder')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      <div
        className={`bg-[#FFF] flex drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] relative`}
      >
        {isLoading ? (
          <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
            <ContentLoading />
          </div>
        ) : null}
        <div className='flex w-full'>
          {remindersBoxes == 1 ? (
            <div className='w-[100%]'>
              <h2
                className='text-[#000000] text-[18px]'
                style={{ fontWeight: '600', lineHeight: '27px', margin: '15px' }}
              >
                {t('My List')}
              </h2>
              <ul>
                {reminders.map((item, index) => (
                  <li
                    key={item.guid || item.id || `reminder-list-${index}`}
                    style={{
                      height: '40px',
                      padding: '10px',
                      marginTop: '10px',
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      position: 'relative'
                    }}
                    onClick={() => handleSelectClick(item.guid)}
                  >
                    <div
                      style={{
                        width: '31px',
                        height: '31px',
                        color: '#FFFFFF',
                        backgroundColor: '#007AFF',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <Icon icon='mdi:format-list-bulleted' fontSize='16px' />
                    </div>

                    <div
                      style={{
                        flex: 1,
                        marginLeft: '10px',
                        borderBottom: '1px solid #C6C6C8',
                        display: 'flex',
                        alignItems: 'center',
                        height: '40px'
                      }}
                    >
                      <span style={{ fontWeight: '600', fontSize: '16px', lineHeight: '24px', color: '#000000' }}>
                        {item.title}
                      </span>

                      <div
                        style={{
                          color: '#8A8A8E',
                          position: 'relative',
                          fontSize: '16px',
                          fontWeight: '400',
                          lineHeight: '24px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                          flex: 1
                        }}
                      >
                        <span>{reminderCount}</span>
                        <span>
                          <Icon icon='material-symbols:chevron-right-rounded' color='#8A8A8E' />
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
          {remindersBoxes == 2 ? (
            <div className='w-[100%] h-[100%] flex flex-col'>
              <div className='px-[15px]'>
                <div style={{ width: '100%', display: 'flex', color: '#000000' }} className='py-[20px]'>
                  <Icon icon='ion:chevron-back' onClick={() => setRemindersBoxes(1)} />{' '}
                  <span
                    style={{
                      textAlign: 'center',
                      fontSize: '18px',
                      lineHeight: '27px',
                      fontWeight: '600',
                      margin: 'auto'
                    }}
                  >
                    {reminderTitle}
                  </span>
                  <div className='w-[24px] h-[24px]'></div>
                </div>
                <div className='flex mx-auto'>
                  {/* 时间选择过滤器 */}
                  <TextField
                    fullWidth
                    className='h-[40px] bg-[rgba(235,235,239,0.92)] rounded-lg !border-0 text-[16px]'
                    size='small'
                    onInput={e => {
                      handleFilter(e)
                    }}
                    placeholder={t('Search Reminders')}
                    sx={{
                      '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': { border: 0 },
                      '& input::placeholder': { fontSize: '16px', color: '#818187', opacity: 100 }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>
                          {/* <Icon icon='mdi:magnify' fontSize='1.25rem' /> */}
                          <Image src='/images/contacts/search.svg' width={18} height={18} alt='search'></Image>
                        </InputAdornment>
                      )
                    }}
                  />
                </div>
              </div>
              <div className='flex-1 overflow-auto pb-5 px-[15px]' style={{ width: '100%', marginTop: '17px' }}>
                <ul>
                  {selectData.map((item, index) => (
                    <li
                      key={item.guid || item.id || `reminder-detail-${index}`}
                      style={{
                        borderBottom: '0.5px solid #C6C6C8',
                        display: 'flex',
                        alignItems: item.dueDate ? 'flex-start' : 'center',
                        flexDirection: item.dueDate ? 'column' : 'row',
                        height: '52px',
                        paddingLeft: '10px',
                        marginTop: '10px'
                      }}
                    >
                      <h3 style={{ fontWeight: '400', fontSize: '16px', lineHeight: '24px', color: '#000000' }}>
                        {item.title}
                      </h3>
                      {item.dueDate && (
                        <span className='text-[#8A8A8E] text-[14px] lineHeight-[19.6px] fontWeight-[400]'>
                          {formatDate(item.dueDate)}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ) : null}
        </div>
        {(reminderCount == 0 && !isLoading) &&
          <div className='text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
    </>
  )
}
export default Reminders



//  {
//    /* 左边 */
//  }
//  ;<Grid item xs={12} md={3} lg={3} className={styles.leftBox}>
//    <div className={styles.list}>
//      <div style={{ paddingTop: '10px', margin: '10px' }}>
//        {/* 时间选择过滤器 */}
//        <TextField
//          fullWidth
//          size='small'
//          onInput={handleFilter}
//          placeholder={t('Search Reminders')}
//          sx={{
//            '& .MuiInputBase-root': { borderRadius: 1 },
//            paddingLeft: '0px'
//          }}
//          InputProps={{
//            startAdornment: (
//              <InputAdornment position='start'>
//                {/* <Icon icon='mdi:magnify' fontSize='1.25rem' /> */}
//                <Image src='/images/contacts/search.svg' width={18} height={18} alt='search'></Image>
//              </InputAdornment>
//            )
//          }}
//        />
//      </div>
//      <ul className={styles.listUl}>
//        {reminders.map(item => (
//          <li
//            key={item.guid}
//            className={active !== item.guid ? styles.listLi : `${styles.listLi} ${styles.listLiSelected}`}
//            onClick={() => handleSelectClick(item.guid)}
//          >
//            <div
//              style={{
//                width: '31px',
//                height: '31px',
//                color: '#FFFFFF',
//                backgroundColor: '#007AFF',
//                borderRadius: '50%',
//                marginLeft: '10px'
//              }}
//            >
//              <Icon icon='mdi:format-list-bulleted' fontSize='16px' style={{ margin: 'auto', marginTop: '7px' }} />
//            </div>
//            <span className={styles.text}>{item.title}</span>
//            <div style={{ width: '31px', height: '31px' }}></div>
//          </li>
//        ))}
//      </ul>
//    </div>
//  </Grid>
//  {
//    /* 右边 */
//  }
//  ;<Grid item xs={12} md={9} lg={9} className={styles.rightBox}>
//    <h3 className={styles.title}>{reminderTitle}</h3>
//    <div className={styles.mainBox}>
//      <ul className={styles.mainUl}>
//        {selectData.map(item => (
//          <li
//            className={styles.mainLi}
//            style={{
//              borderBottom: '1px solid #C6C6C8',
//              display: 'flex',
//              alignItems: item.dueDate ? 'flex-start' : 'center',
//              flexDirection: item.dueDate ? 'column' : 'row',
//              height: '50px'
//            }}
//            key={item.id}
//          >
//            <h3 className={styles.mainTitle}>{item.title}</h3>
//            <span className={`${styles.mainTime}  ${!item.dueDate ? styles.centeredTitle : ''}`}>
//              {formatDate(item.dueDate)}
//            </span>
//          </li>
//        ))}
//      </ul>
//    </div>
//  </Grid>
